import { FC, JSX, useEffect, useState } from "react";
import { Container, Heading } from "@radix-ui/themes";
import JobInputForm from "@/features/jobs/components/manage/JobInputForm";
import { useUpdateJob } from "@/features/jobs/hooks/useUpdateJob";
import { useParams } from "react-router-dom";
import { useSingleJob } from "@/features/jobs/hooks/useSingleJob";
import { Job } from "@/models/Job.model";
import { timestamp } from "@/api/firebase/firebase.config";

const JobsManagePage: FC = (): JSX.Element => {
  const { slug } = useParams();
  const { data } = useSingleJob(slug || "");
  const { updateJobListing, loading, error } = useUpdateJob(data?.id || "");

  const [values, setValues] = useState<Job>({
    slug: "",
    status: "published",
    created_at: timestamp.now(),
    created_by: "",
    position: "",
    brand: "",
    event: "",
    event_dates: {
      start: timestamp.now(),
      end: timestamp.now(),
    },
    application_deadline: timestamp.now(),
    compensation: "",
    descriptions: {
      role: "",
      event: "",
      responsibilities: "",
      qualifications: "",
      offer: "",
    },
  } as Job);

  useEffect(() => {
    if (data) {
      setValues(data);
    }
  }, [data]);

  return (
    <>
      <Container px={{ initial: "4", lg: "0" }}>
        <Heading size="4" mb="3">
          Edit a Job
        </Heading>
        <JobInputForm
          loading={loading}
          error={error}
          handleSubmit={updateJobListing}
          values={values}
          setValues={setValues}
          buttonText="Update Job"
        />
      </Container>
    </>
  );
};

export default JobsManagePage;
